import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RegisterFcmTokenRequest, FcmTokenResponse } from '../../interfaces/fcm/fcm-interfaces';

@Injectable({
  providedIn: 'root',
})
export class FcmGatewayService {
  private urlPrefix: string = '/api/fcm';

  constructor(private httpClient: HttpClient) {}

  public registerToken(request: RegisterFcmTokenRequest): Observable<FcmTokenResponse> {
    const url = `${environment.api.url}${this.urlPrefix}/tokens/register`;
    return this.httpClient.post<FcmTokenResponse>(url, request);
  }
}
